import { type Experiment } from '@grammarly/experimentation-js-sdk'

// import { PixelExperiment } from './pixel-experiment'

export const Experiments: Record<string, Experiment> = {
  // Example experiment - update with actual experiments as needed
  // ExampleStatsigExperiment: new PixelExperiment('example_statsig_experiment', ['control', 'test']),
} as const

export const ExperimentNamesSet: Set<string> = new Set(
  Object.values(Experiments).map(experiment => (experiment as Experiment<any>).name),
)
